import type { PersonalizeItem } from "./schemas";

export const FORMATS = {
  soft: { id: "soft", name: "Softcover", priceCents: 3400, sub: "Lightweight · easy for little hands" },
  hard: { id: "hard", name: "Hardcover", priceCents: 4900, sub: "Sewn-bound · the keepsake classic" },
  flat: { id: "flat", name: "Lie-Flat Hardcover", priceCents: 7400, sub: "Photo-album binding · opens flat" },
} as const;

export type FormatId = keyof typeof FORMATS;
export type FormatRecord = (typeof FORMATS)[FormatId];

export const FREE_SHIPPING_CENTS = 4000;
export const FLAT_SHIPPING_CENTS = 500;
export const TAX_RATE = 0.0875;

export type Totals = {
  subtotalCents: number;
  shippingCents: number;
  taxCents: number;
  totalCents: number;
};

export function itemPriceCents(item: Pick<PersonalizeItem, "format">): number {
  return FORMATS[item.format].priceCents;
}

export function computeTotals(items: Array<Pick<PersonalizeItem, "format">>): Totals {
  const subtotalCents = items.reduce((s, i) => s + itemPriceCents(i), 0);
  const shippingCents = items.length === 0 || subtotalCents >= FREE_SHIPPING_CENTS ? 0 : FLAT_SHIPPING_CENTS;
  const taxCents = Math.round(subtotalCents * TAX_RATE);
  return {
    subtotalCents,
    shippingCents,
    taxCents,
    totalCents: subtotalCents + shippingCents + taxCents,
  };
}

export function centsToDollars(c: number): string {
  return (c / 100).toFixed(2);
}
